'use strict';

/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

var backgroundreplace = $('.shadefinderWrapper-replace');
var vtoBackgroundImage = $('.vto-background-image');
var useMobileView = $(window).outerWidth() < 500;

if (backgroundreplace) {
    $('.shadefinderWrapper, .vto-wrapper').css({'background-image': 'url(' + backgroundreplace.html() + ')', 'background-repeat':'no-repeat', 'background-size':'100% 100%'});
}

if (vtoBackgroundImage) {
    var html = "<img class='background-vto-image' alt='background vto raso' src='" + vtoBackgroundImage.html() + "' />";
    $("#virtualtry-wrapper-raso").prepend(html);
}

var urlParams;
(window.onpopstate = function () {
    var match,
        pl     = /\+/g,  // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
        query  = window.location.search.substring(1);

    urlParams = {};
    while ((match = search.exec(query)) != null) { // eslint-disable-line no-cond-assign
        urlParams[decode(match[1])] = decode(match[2]);
    }
})();

function filterColorVTO(){
    var productshade = urlParams["product"];
    var shadeId = urlParams["shadeid"];
    var windowSize = $(window).width();
    var $owltryon = $('.tryon-mobile, .tryon-mobile-no-slider');

    if (useMobileView) {
        $('.tryon-mobile .shadefinder-shadesquare, .tryon-mobile-no-slider .shadefinder-shadesquare').each(function(){
            var attr = $(this).attr('data-value');
            if(attr === productshade || $(this).attr('data-shadeid') === shadeId){
                var selectedStartValue = $(this);
                if($(this).closest('.tryon-mobile').hasClass(attr)){
                    if(!($(this).parent().hasClass('active'))){
                        
                        $('.aqua-resist-choose-group-display-button').removeClass('active');
                        $('.aqua-resist-choose-group-display-button').attr('data-value', attr).addClass('active');
                        $('.tryon-mobile').removeClass('active').hide();
                        $('.tryon-mobile').hasClass(attr).addClass('active').show();
                    }
                }
                document.addEventListener('YMKloaded', function () {
                    window.YMK.applyMakeupBySku(selectedStartValue.attr('data-value'));
                    $owltryon.trigger('to.owl.carousel', selectedStartValue.data('position'));
                    selectedStartValue.trigger('click');
                    if ($(".VTOcamera-iconcontainer").hasClass('active')) {
                        $('#YMK-wrapper .VTOpicture-iconcontainer').show();
                    } else {
                        $('#YMK-wrapper .VTOcamera-iconcontainer').show();
                        $('#YMK-wrapper .VTOpicture-iconcontainer').show();
                    }
                });
                selectedStartValue.trigger('click');
            }
        });
    } else {
        $('.landing-rouge-shade-interact-module-shade-svgcontainer .shadefinder-shadesquare, .landing-rouge-shade-interact-module-shade-svgcontainer path').each(function(){
            var attr = $(this).attr('data-value');
            if(attr === productshade || $(this).attr('data-shadeid') === shadeId){
                var selectedStartValue = $(this);
                if($(this).parent().hasClass(attr)){
                    if(!($(this).parent().hasClass('active'))){
                        
                        $('.aqua-resist-choose-group-display-button').removeClass('active');
                        $('.aqua-resist-choose-group-display-button').attr('data-value', attr).addClass('active');
                        $('.landing-rouge-shade-interact-module-shade-svgcontainer').removeClass('active').hide();
                        $('.landing-rouge-shade-interact-module-shade-svgcontainer').hasClass(attr).addClass('active').show();
                    }
                }
                document.addEventListener('YMKloaded', function () {
                    window.YMK.applyMakeupBySku(selectedStartValue.attr('data-value'));
                    if ($(".VTOcamera-iconcontainer").hasClass('active')) {
                        $('#YMK-wrapper .VTOpicture-iconcontainer').show();
                    } else {
                        $('#YMK-wrapper .VTOcamera-iconcontainer').show();
                        $('#YMK-wrapper .VTOpicture-iconcontainer').show();
                    }
                });
                selectedStartValue.trigger('click');
            }
        });
    }
}

var dataurl = $('.landing-rouge-shade-interact-module-shade').attr('data-url');
$('.landing-rouge-shade-interact-module-shade path').attr('data-url', dataurl);
$('.landing-rouge-shade-interact-module-shade.vto-sephora .shadefinder-shadesquare').attr('data-url', dataurl);
$('.landing-rouge-shade-interact-module-shade.vto-rougeartist .shadefinder-shadesquare').attr('data-url', dataurl);
$('.tryon-mobile .shadefinder-shadesquare, .tryon-mobile-no-slider .shadefinder-shadesquare').attr('data-url', dataurl);
$('#aquaresist-wrapper .shadefinder-shadesquare, #mascarapro-wrapper .shadefinder-shadesquare, #mascarapro-wrapper-sephora .shadefinder-shadesquare').attr('data-url', dataurl);
$.spinner().start();
var windowSize = $(window).outerWidth();
var windowHeight = $(window).outerHeight();

function uploadPicture(input) {
    if (input.files && input.files[0]) {
        $(".VTOcamera-iconcontainer").removeClass('active');
        $('#YMK-wrapper .VTOpicture-iconcontainer').hide();

        var reader = new FileReader();
        reader.readAsDataURL(input.files[0]); // convert to base64 string

        reader.onload = function (e) {
            window.YMK.open( false , e.target.result); // reload module with upload image
        }
    }
}

function reloadmodule() {
    $(".VTOcamera-iconcontainer").addClass('active');
    $('#YMK-wrapper .VTOcamera-iconcontainer').hide();
    $('#YMK-wrapper .VTOpicture-iconcontainer').hide();
    window.YMK.open();
    $("#VTOpicture").val('');
}

$("#VTOpicture").change(function () {
    uploadPicture(this);
});

$(".VTOcamera-iconcontainer").click(function () {
    reloadmodule();
});

window.ymkAsyncInit = function () {
    var event = new Event('YMKloaded');

    window.YMK.addEventListener('loaded', function () {
        setTimeout(
            function () {
                document.dispatchEvent(event);
            }, 1000
        );
    });

    window.YMK.addEventListener('closed', function () {
        $('.VTOpicture-iconcontainer').hide();
        $('.skintone-title-mobile').hide();
        if (useMobileView) {
            var locationPDP = $('.shadefinderWrapper-Revamp').data('url');
            $('.custom-shade-search').hide();
            $(location).attr('href', locationPDP);
        }

    });

    window.YMK.addEventListener('backToLive', function () {
        if (useMobileView) {
            $('.custom-shade-search').show();
            $('.skintone-title-mobile').show();
        }
    });

    window.YMK.addEventListener('enterTakePhoto', function () {
        if (useMobileView) {
            $('.custom-shade-search').hide();
            $('.skintone-title-mobile').hide();
        }
    }); 

    var initParameters = {
        userConsent: 'agree',
        enableFourWayLooks: false,
        language: PropertiesPreferences.VTO_DATA_LANG
    };

    if (useMobileView) {
        initParameters.width = windowSize;
        initParameters.height = 476;

        if ($('.shadefinderWrapper-Revamp').length) {
            if ($('header').length) {
                $('.shadefinderWrapper-Revamp').addClass('shadefinderWrapper-RevampStand');
                initParameters.height = windowHeight - ($('header').height());
            }else {
                initParameters.height = windowHeight;
                $('#YMK-module').css('height', windowHeight + 'px');
            }
            
            $('#YMK-wrapper').css('top', $('header').height() + 'px');
            $('.suggestions-shade-details').css('width', windowSize + 'px');
            $('body').addClass('lock-body');
        }

    } else if (windowSize > 500 && windowSize < 992){
        initParameters.width = 544;
        initParameters.height = 619;
    } else if (windowSize > 991 && windowSize < 1200) {
        initParameters.width = 480;
        initParameters.height = 700;
    } else {
        initParameters.width = 500;
        initParameters.height = 619;
    }

    // Open VTO module
    window.YMK.init(initParameters);

    if ($("#optin-vto-shadefiner").length) {
        $("#optin-vto-shadefiner").modal("show");

        $(".button-optin-submit").on("click", function() {
            $("#optin-vto-shadefiner").modal("hide");
            window.YMK.open();
        })
    } else {
        window.YMK.open();
    }
    var $owltryon = $('.tryon-mobile, .tryon-mobile-no-slider');
    if(urlParams["product"] !== undefined || urlParams["shadeid"] !== undefined){
        setTimeout(filterColorVTO, 1000);
    }else{
        var selectedfirstelementdesktop = $('.landing-rouge-shade-interact-module-shade .first-clicked');
        var selectedfirstelementmobile = $('.tryon-mobile .shadefinder-shadesquare.first-clicked, .tryon-mobile-no-slider .shadefinder-shadesquare.first-clicked');
        $('.custom-shade-search').addClass('active');
        if (useMobileView) {
            document.addEventListener('YMKloaded', function () {
                selectedfirstelementmobile.trigger('click');
                window.YMK.applyMakeupBySku(selectedfirstelementmobile.attr('data-value'));
                
                $owltryon.find('.owl-item').each(function () {
                    var self = $(this);
                    var urlOwlItem = self.find('.shadefinder-shadesquare.active').data('url-sephora');

                    $('.shadefinderWrapper-Revamp').attr('data-url', urlOwlItem);
                    
                    if (self.find('.is-outStock').length) {
                        self.append('<span class="strock-line"></span>');
                    }

                    if (self.find('.is-outStock').hasClass('active')) {
                        self.addClass('is-outStock').siblings('.is-outStock').removeClass('is-outStock');
                    }

                    self.on('click', function () {
                        var dataUrlItem = self.find('.shadefinder-shadesquare').data('url-sephora');

                        $('.shadefinderWrapper-Revamp').attr('data-url', dataUrlItem);
                        
                        if (self.find('.is-outStock').hasClass('active')) {
                            self.addClass('is-outStock').siblings('.is-outStock').removeClass('is-outStock');
                        } else {
                            self.removeClass('is-outStock').siblings().removeClass('is-outStock');
                        }
                    });
                });

                if(selectedfirstelementmobile.length > 0){
                    $owltryon.trigger('to.owl.carousel', selectedfirstelementmobile.data('position'));
                }
                if($(".VTOcamera-iconcontainer").hasClass('active')){
                    $('#YMK-wrapper .VTOpicture-iconcontainer').show();
                } else {
                    $('#YMK-wrapper .VTOcamera-iconcontainer').show();
                    $('#YMK-wrapper .VTOpicture-iconcontainer').show();
                }
                $('.skintone-title-mobile').show();
            });
        } else {
            selectedfirstelementdesktop.trigger('click');
            window.YMK.applyMakeupBySku(selectedfirstelementdesktop.attr('data-value'));
            
            document.addEventListener('YMKloaded', function () {
                window.YMK.applyMakeupBySku(selectedfirstelementdesktop.attr('data-value'));
                if($(".VTOcamera-iconcontainer").hasClass('active')){
                    $('#YMK-wrapper .VTOpicture-iconcontainer').show();
                } else {
                    $('#YMK-wrapper .VTOcamera-iconcontainer').show();
                    $('#YMK-wrapper .VTOpicture-iconcontainer').show();
                }
            });
        }
    }
    $.spinner().stop();
}

$(document).on('click', '.aqua-resist-choose-group-display-button', function () {
    
    if(!($(this).hasClass('active'))){
        var attr = $(this).attr('data-value');
        var block1 = $('[data-value=block1]');
        var block2 = $('[data-value=block2]');
        var block3 = $('[data-value=block3]');
        var block4 = $('[data-value=block4]');

        $('.aqua-resist-choose-group-display-button').removeClass('active');
        $(this).addClass('active');
        $(this).removeClass('separator');
        
        
        if(typeof attr !== typeof undefined && attr !== false){

            if (block4.length) {
                if(attr === "block1") {
                    block2.addClass('separator');
                    block1.removeClass('separator');
                    block3.addClass('separator');
                } else if(attr === "block2") {
                    block1.removeClass('separator');
                    block2.removeClass('separator');
                    block3.addClass('separator');
                } else if(attr === "block3") {
                    block1.addClass('separator');
                    block2.removeClass('separator');
                    block3.removeClass('separator');
                } else {
                    block1.addClass('separator');
                    block2.addClass('separator');
                    block3.removeClass('separator');
                }
            }else {
                if(attr === "block1") {
                    block2.addClass('separator');
                    block1.removeClass('separator');
                    block3.removeClass('separator');
                } else if(attr === "block2") {
                    block1.removeClass('separator');
                    block2.removeClass('separator');
                    block3.removeClass('separator');
                } else {
                    block1.addClass('separator');
                    block2.removeClass('separator');
                    block3.removeClass('separator');
                }
            }
            
            if($(window).width() > 500){
                $('.landing-rouge-shade-interact-module-shade-svgcontainer').addClass('d-none').removeClass('active');
                $('.landing-rouge-shade-interact-module-shade-svgcontainer').each(function(){
                    if($(this).hasClass(attr)){
                        $(this).find('.shadefinder-shadesquare:first-child').trigger('click');
                        $(this).removeClass('d-none');
                        $(this).addClass('active');
                    }
                })
            } else{
                $('.tryon-mobile, .tryon-mobile-no-slider').addClass('d-none').removeClass('active');
                $('.tryon-mobile, .tryon-mobile-no-slider').each(function(){
                    if($(this).hasClass(attr)){
                        $(this).removeClass('d-none');
                        $(this).addClass('active');
                        $(this).find('.shadefinder-shadesquare').first().trigger('click');
                        $(this).find('.shadefinder-shadesquare').parents('.center').siblings('.owl-item').removeClass('is-outStock').find('.shadefinder-shadesquare').removeClass('active');
                        $(this).find('.shadefinder-shadesquare').parents('.center').find('.shadefinder-shadesquare').addClass('active').trigger('click');
                        $(this).find('.shadefinder-shadesquare.is-outStock').parents('.center').addClass('is-outStock');
                    }
                })
            }
        }
    }
})

$('.landing-rouge-shade-interact-module-shade-svgcontainer .shadefinder-shadesquare').each(function () {
    $(this).on('click', function () {
        if ($(this).parent('.shade-spiral, .shade-spiral-pd').find('.is-outStock')) {
            $(this).parent('.shade-spiral, .shade-spiral-pd').addClass('active').siblings('.shade-spiral, .shade-spiral-pd').removeClass('active');
        }
    });
})